import { render, staticRenderFns } from "./NewReleases.vue?vue&type=template&id=98d710f8"
import script from "./NewReleases.vue?vue&type=script&lang=js"
export * from "./NewReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports